import { RefObject, useEffect } from 'react'

type Props = {
  ref: RefObject<HTMLElement | null>
  onClose: () => void
  isOpen: boolean
  disabled?: boolean
}

export const useOutsideClick = ({
  ref,
  onClose,
  isOpen,
  disabled = false
}: Props) => {
  useEffect(() => {
    if (!isOpen || disabled) {
      return
    }

    const handleClickOutside = (event: MouseEvent) => {
      if (ref.current && !ref.current.contains(event.target as Node)) {
        onClose()
      }
    }

    document.addEventListener('mousedown', handleClickOutside)

    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [ref, onClose, isOpen, disabled])
}
